<template>
    <div>
        <v-fab-transition v-if="employeeId === userLogin && $vuetify.breakpoint.smAndDown">
            <v-btn
                color="primary"
                fab
                dark
                fixed
                bottom
                left
                @click="$refs.VisitDialog.addVisit()"
            >
                <v-icon>mdi-plus</v-icon>
            </v-btn>
        </v-fab-transition>
        <!-- visits -->
        <v-dialog
			v-model="dialogPriceType"
			width="400"
			@keydown.esc="dialogPriceType = false"
        >
            <v-card>
                <div class="d-flex py-1 primary">
                    <v-card-title
                        class="text-uppercase flex-grow-1 text-subtitle-1 justify-center pa-0 white--text"
                    >
                        {{ $t('add-prices-for-an-item') }}
                    </v-card-title>

                    <v-btn icon @click="dialogPriceType = false">
                        <v-icon color="white"> mdi-close-circle-outline </v-icon>
                    </v-btn>
                </div>

                <v-card-text>
                    <v-row class="mt-3">
                        <p class="mb-2">
                            {{ $t('please-enter-the-type-price-for-this-item', { type: pricesTypes.find(c => c.id === priceType)?.name }) }}
                        </p>
                        <v-col 
                            sm="6" 
                            cols="12" 
                            class="pa-1"
                        >
                            <v-text-field
                                v-model.number="price"
                                clearable
                                outlined
                                dense
                                hide-details="auto"
                                :label="$t('inputs.price')"
                                :loading="submitLoading"
                                :disabled="submitLoading"
                                autofocus
                            />
                        </v-col>

                        <v-col 
                            sm="6" 
                            cols="12" 
                            class="pa-1"
                        >
                            <v-text-field 
                                v-model.number="priceDiscountRate"
                                clearable
                                outlined
                                dense
                                hide-details="auto"
                                :label="$t('inputs.discount-rate')"
                                :disabled="submitLoading"
                            />
                        </v-col>
                    </v-row>
                </v-card-text>

                <v-card-actions class="justify-end pt-0">
                    <v-btn
                        type="submit"
                        color="success"
                        text
                        :loading="submitLoading"
                        @click="updatePrices()"
                    >
                        {{$t('save')}}
                    </v-btn>
                    <v-btn
                        @click="dialogPriceType = false"
                        text
                        :disabled="submitLoading"
                    >
                        {{$t('cancel')}}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <!-- visit dialog is declared here to use it as ref -->
        <visit-dialog 
            ref="VisitDialog"
            @on-save="fetchVisits" 
            @on-open="fetchAndAction($event)"
            :create="date" 
        />
        
        <!-- delete dialog declaered here to use it as ref -->
        <delete-dialog ref="DeleteDialog" @on-delete="fetchVisits">
            <p class="mb-0 text-body-1">
                {{ $t('are-you-sure-you-want-to') }} <span class="red--text">{{ $t('delete') }}</span> {{$t('AdministrativeVisit.the-visit')}} {{$t('?')}}
            </p>
        </delete-dialog>

        <!-- filter -->
        <v-row no-gutters class="justify-space-between align-center">
            <!-- month dialog -->
            <v-col md="auto" cols="12">
                <v-dialog
                    ref="dialog"
                    v-model="monthDialog"
                    :return-value.sync="selectedMonth"
                    persistent
                    max-width="300px"
					@keydown.esc="monthDialog = false"
                >
                    <!-- date text -->
                    <template v-slot:activator="{ on, attrs }">
                        <div
                            v-bind="attrs"
                            v-on="on"
                            class="d-flex justify-space-between align-center primary--text"
                        >
                            <div class="d-flex align-center">
                                <v-icon class="me-2" color="primary">mdi-calendar</v-icon>
                                <span class="text-h5 me-2">
                                    {{ moment(date, 'YYYY-MM-DD').locale($i18n.locale).format('MMMM')}}
                                </span>
                                <span class="text-subtitle-2 align-self-end">
                                    {{moment(date, 'YYYY-MM-DD').format('YYYY')}}
                                </span>
                            </div>

                            <v-btn
                                v-if="$vuetify.breakpoint.smAndDown"
                                color="primary"
                                small
                                outlined
                                @click="goToTodayDate"
                            >
                                {{$t('AdministrativeVisit.today')}}
                            </v-btn>
                        </div>
                    </template>

                    <!-- dialog date picker -->
                    <v-date-picker
                        v-model="selectedMonth"
                        full-width
                        picker-date
                        type="month"
                        :max="(new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10)"
                    >
                        <v-spacer></v-spacer>
                        <v-btn
                            text
                            color="primary"
                            @click="monthDialog = false"
                        >
                            {{$t('cancel')}}
                        </v-btn>
                        <v-btn
                            text
                            color="primary"
                            @click="
                                $refs.dialog.save(selectedMonth);
                                date = moment(selectedMonth, 'YYYY-MM').format('YYYY-MM-DD');
                                fetchVisits();
                            "
                        >
                            {{$t('ok')}}
                        </v-btn>
                    </v-date-picker>
                </v-dialog>
            </v-col>

            <!-- days picker -->
            <v-col md="auto" cols="12" class="flex-grow-1">
                <v-month-days
                    v-model="date"
                    :month="selectedMonth"
                    :max-width="$vuetify.breakpoint.mdAndUp ? $vuetify.breakpoint.width - 400 : null"
                    :disabled="loading"
                    class="mx-auto"
                    @input="fetchVisits"
                />
            </v-col>

            <!-- today button -->
            <v-col  cols="auto" v-if="$vuetify.breakpoint.mdAndUp">
                <v-btn
                    color="primary"
                    small
                    outlined
                    @click="goToTodayDate"
                >
                    {{ $t('AdministrativeVisit.today') }}
                </v-btn>
            </v-col>
        </v-row>

        <div class="d-flex flex-wrap align-center pt-0">
            <span class="text-body-1 me-6">{{$t('AdministrativeVisit.filter')}}</span>
            <v-chip-group
                v-model="selectedFilter"
                show-arrows
                center-active
                active-class="success"
                @change="fetchVisits"
            >
                <v-chip v-for="(type, index) in customersTypes" :key="index" filter outlined :value="type.id" :disabled="loading">
                    {{ type.name }}
                </v-chip>
        
            </v-chip-group>
            <!-- employees -->
            <v-col cols="12" sm="3">
                <v-autocomplete 
                    v-model="employeeId"
                    :items="medicalRepsBrief.filter(c => c.employeeType !== 1)" 
                    item-text="name"
                    item-value="id"
                    :label="$t('inputs.employee')"
                    outlined
                    dense
                    hide-details
                    clearable
                    @change="fetchVisits"
                    :disabled="loading"
                />
            </v-col>
            
            <v-spacer/>

            <!-- add visit -->
            <v-btn
                v-if="employeeId === userLogin && $vuetify.breakpoint.mdAndUp"
                small
                color="light-blue white--text"
                :disabled="!isDateMatchTodayDate"
                @click="$refs.VisitDialog.addVisit()"
            >
                <v-icon class="me-1" size="22">mdi-plus-circle-outline</v-icon>
                {{$t('AdministrativeVisit.add-visit')}}
            </v-btn>

            <v-divider v-if="excelFile" vertical class="mx-1 my-2" />

            <v-btn
                v-if="excelFile"
                small
                color="green lighten-1 white--text"
                @click="ImportExcel"
                class="mx-1"
                :loading="loadingExcel"
                :disabled="loadingExcel || !employeeId"
            >
                <v-icon> mdi-file-table-outline </v-icon>
                {{$t('export-excel')}}
            </v-btn>
        </div>
 
        <!-- table -->
        <bee-handy-table
            v-if="$vuetify.breakpoint.mdAndUp"
            :headers="headers"
            :items="visits"
            :loading="loading"
            zebra
            dense
            :data-table-props="{ disableSort: true }"
            :items-per-page="-1"
            hide-default-footer
            fixed-header
            class="mt-1"
        >
            <template v-slot:item.actions="{ item }">
                <!-- edit -->
                <tooltip v-if="isDateMatchTodayDate" :text="$t('edit')" top>
                    <v-btn
                        icon
                        small
                        color="success"
                        class=""
                        @click="$refs.VisitDialog.editVisit(item.id, date)"
                        :disabled="loading"
                    >
                        <v-icon>mdi-pencil</v-icon>
                    </v-btn>
                </tooltip>

                <!-- delete -->
                <tooltip v-if="isDateMatchTodayDate" :text="$t('delete')" top>
                    <v-btn
                        icon
                        small
                        color="red lighten-1"
                        @click="$refs.DeleteDialog.activeDeleteDialog(item.id, 'visits')"
                        :disabled="loading"
                    >
                        <v-icon>mdi-delete</v-icon>
                    </v-btn>
                </tooltip>

                <tooltip :text="$t('print')" top>
                    <v-menu offset-y>
                        <template v-slot:activator="{ attr, on }">
                            <v-btn
                                small
                                depressed
                                v-on="on"
                                v-bind="attr"
                                @click="invoiceId = item.id"
                                color="transparent"
                                :loading="loading && invoiceId === item.id"
                                :disabled="loading"
                                icon
                            >
                                <v-icon color="primary">mdi-printer</v-icon>
                            </v-btn>
                        </template>

                        <v-list dense>
                            <v-list-item @click="invoiceId = item.id, printReport(invoiceId, true)">
                                <v-list-item-title>
                                    {{ $t('invoices.office-invoice') }}
                                </v-list-item-title>
                            </v-list-item>
                            <v-list-item @click="invoiceId = item.id, printReport(invoiceId, false)">
                                <v-list-item-title>
                                    {{ $t('invoices.pos-invoice') }}
                                </v-list-item-title>
                            </v-list-item>
                        </v-list>
                    </v-menu>
                </tooltip>
            </template>
        </bee-handy-table>

        <div v-else v-for="(visit, index) in visits" :key="index">
            <!-- -->
            <visit-card
                :visit="visit"
                :disabled="false"
                @on-edit="$refs.VisitDialog.editVisit(visit.id, date)"
                @on-swipe-right="$refs.DeleteDialog.activeDeleteDialog(visit.id, 'visits')"
            ></visit-card>
        </div>
    </div>
</template>

<script>
import DeleteDialog from '@/components/DeleteDialog'
import Tooltip from '@/components/Tooltip'
import VisitDialog from '@/components/VisitDialog'
import VMonthDays from '@/components/VMonthDays.vue'
import { mapGetters, mapState } from 'vuex'
import moment from 'moment'
import { userType } from '@/helpers/enums'
import { excelFile, addPrice, enablePricesTypes, enableCustomerType, managementPriceType } from '@/configs/global.config'
import VisitCard from '@/pages/VisitCard.vue'
import rules from '@/validation rules'
export default {
	data() {
		return {
            excelFile,
            employeeId: this.$route.query.employeeId ? this.$route.query.employeeId : null,
			monthDialog: false,
			loading: true,
			selectedFilter: null,
			selectedMonth: moment().format('YYYY-MM'),
			date: moment().format('YYYY-MM-DD'),
            userType,
            visits: [],
            loadingExcel: false,
            addPrice,

            location:null,
            gettingLocation: false,
            errorStr:null,
            enablePricesTypes,
            enableCustomerType,
            dialogPriceType: false,
            managementPriceType,
            price: 0,
            priceDiscountRate: 0,
            submitLoading: false,
            pricesMaterial: [],
            materialId: null,
            material: null,
            priceType: null,
            sampleId: null,
            invoiceId: null,
            rules
        }
	},

    watch: {
        dialogPriceType (val) {
            if (!val) {
                this.price = 0
                this.priceDiscountRate = 0
            }
        }
    },

    components: {
		DeleteDialog,
		Tooltip,
		VisitDialog,
		VMonthDays,
        VisitCard
	},

	computed: {
		// filteredVisits() {
		// 	if (this.selectedFilter !== null && this.selectedFilter !== undefined) {
		// 		return this.visits.filter(c => c.entity.entityType === this.selectedFilter);
		// 	} else {
		// 		return this.visits;
		// 	}
		// },

		...mapState({
            regions: state => state.regions.regions,
            cities: state => state.cities.cities,
            medicalRepsBrief: state => state.medicalreps.medicalRepsBrief,
            specialties: state => state.specialties.specialties,
            userLogin: state => state.auth.self.employeeId,
            pricesTypes: state => state.pricesTypes.pricesTypes,
            myMaterials: state => state.materials.myMaterials,
            customersTypes: state => state.entityType.customersTypes,
            materials: state => state.materials.materials
		}),

        ...mapGetters({
            getMaterialById: 'materials/getMaterialById',
            getSpecialtyById: 'specialties/getSpecialtyById',
        }),
        
        isDateMatchTodayDate() {
            return (this.date === moment().format('YYYY-MM-DD')) || 
                (this.date === moment().subtract(1, 'days').format('YYYY-MM-DD')) || 
                (this.date === moment().subtract(2, 'days').format('YYYY-MM-DD'))
        },

        headers() {
            const headers = [
                {
                    text: this.$t('headers.entity-name'),
                    name: 'entityName',
                    value: 'entityName',
                },
                {
                    text: this.$t('headers.specialty'),
                    name: 'entitySpecialty',
                    value: 'entitySpecialtyId',
                    setValueExpr: val => val.map(c => this.getSpecialtyById(c)?.name).join(', ')
                },
                {
                    text: this.$t('headers.sample-name'),
                    name: 'sample',
                    value: 'materialAmounts',
                    setValueExpr: val => val.map(c => this.getMaterialById(c.materialId)?.name).join(', ')
                },
                {
                    text: this.$t('headers.samples-amount'),
                    name: 'amount',
                    value: 'materialAmounts',
                    setValueExpr: val => val.map(c => c.amount).join(', ')
                },
				addPrice ? {
					text: this.$t('headers.amount-received'),
					value: 'amountReceived',
					name: 'amount-received',
					type: 'number',
					align: 'start',
				} : null,
                {
                    text: this.$t('headers.other-samples'),
                    name: 'otherSamples',
                    value: 'otherSamples'
                },
                {
                    text: this.$t('headers.core-message'),
                    name: 'coreMessage',
                    value: 'coreMessage'
                },
                {
                    text: this.$t('headers.objection'),
                    name: 'objections',
                    value: 'objections'
                },
                {
                    text: this.$t('headers.duration'),
                    name: 'durationInMinutes',
                    value: 'durationInMinutes',
                    noNotAvailableText: true,
                    setValueExpr: val => val + ' min' 
                },
            ];

            // if (this.isDateMatchTodayDate) {
                headers.push({
                    text: '',
                    name: 'actions',
                    value: 'actions',
                    width: 140,
                    sortable: false
                })
            // }
            return headers.filter(c => c !== null)
        }
	},

    methods: {
		moment,
        fetchAndAction (material) {
            this.material = material
            this.dialogPriceType = true
            this.material = material
            this.priceType = material.priceType
            this.sampleId = material.id
            if (this.managementPriceType) {
                this.pricesMaterial = this.myMaterials?.find(c => c.id === this.material.materialId)?.prices === null 
                    ? [] 
                    : this.myMaterials.find(c => c.id === this.material.materialId)?.prices
                this.materialId = material.materialId
            }
        },
		
		fetchVisits() {
            this.loading = true;
            this.$store.dispatch('visits/fetchByFilter', { 
                IsMedicalRep: false, 
                employeeIds: this.employeeId ? [this.employeeId] : [this.userLogin], 
                fromDate: this.date ? this.date : moment().format('YYYY-MM-DD'),
                toDate: this.date ? this.date : moment().format('YYYY-MM-DD'),
                regionIds: [],
                // entityType: this.selectedFilter,
                entityTypeId: this.selectedFilter,
                entityIds: []
            }).then((data) => {
                this.visits = data.data
            }).finally(() => {
                this.loading = false
            })
		},

		editPrevent(message) {
			this.$eventBus.$emit('show-snackbar', message, 'info');
		},

		goToTodayDate() {
			const todayDate = moment().format('YYYY-MM-DD');
			if (this.date !== todayDate) {
                this.selectedMonth = moment().format('YYYY-MM');
                this.date = todayDate;
                this.fetchVisits();
			}
		},
        ImportExcel() {
            this.loadingExcel = true
            this.$store.dispatch('exporter/fetchVisitsExport', { 
                FromDate: this.date, 
                ToDate: this.date, 
                EmployeeId: this.employeeId,
            }).finally(() => {
                this.loadingExcel = false
            })
        },

        updatePrices () {
            if (this.managementPriceType) {
                this.submitLoading = true
                if (this.pricesMaterial.find(c => c.priceId === this.material.priceType)?.price === 0) {
                    this.pricesMaterial.find(c => c.priceId === this.material.priceType).price = this.price
                    this.pricesMaterial.find(c => c.priceId === this.material.priceType).priceId = this.material.priceType
                    this.pricesMaterial.find(c => c.priceId === this.material.priceType).priceDiscountRate = this.priceDiscountRate
                } 
                else if (!this.pricesMaterial.find(c => c.priceId === this.material.priceType)) {
                    this.pricesMaterial.push({
                        price: this.price,
                        priceId: this.material.priceType,
                        priceDiscountRate: this.priceDiscountRate
                    })
                }
        
                this.$store.dispatch('materials/updatePrices', { 
                    newPrices: this.pricesMaterial.map(c => ({ price: c.price, priceId: c.priceId, priceDiscountRate: c.priceDiscount })),
                    id: this.materialId,
                }).then(() => {
                    this.$refs.VisitDialog.getPrice({ materialId: this.materialId, id: this.sampleId })
                    if (this.dialogPriceType === true) {
                        this.$store.dispatch('materials/fetchMyMaterial', { 
                            employeeId: this.userLogin,
                            withPrices: this.addPrice 
                        })
                    }
                    this.dialogPriceType = false
                }).finally(() => {
                    this.submitLoading = false
                })
            }
        },

        printReport (id, isPosDevice) {
            this.loading = true
            this.$store.dispatch('exporter/printReport', { 
                visitId: id,
                posDevice: isPosDevice
            }).finally(() => {
                this.loading = false
            })
        }
	},

	created() {
		this.loading = true;
        this.date = this.$route.query.date ? this.$route.query.date : this.moment().format('YYYY-MM-DD')

		Promise.all([
            this.$store.dispatch('visits/fetchByFilter', { 
                IsMedicalRep: false, 
                employeeIds: [this.userLogin], 
                fromDate: this.date ? this.date : moment().format('YYYY-MM-DD'),
                toDate: this.date ? this.date : moment().format('YYYY-MM-DD'),
                regionIds: [],
                // entityType: this.selectedFilter,
                entityTypeId: this.selectedFilter,
                entityIds: []
            }).then((data) => {
                this.visits = data.data
            }),
			!this.materials.length ? this.$store.dispatch('materials/fetchAll', {}) : null,
			this.$store.dispatch('materialTransactions/fetchAll', { queryType: userType.supervisor }),
			this.$store.dispatch('materialForms/fetchAll'),
            this.$store.dispatch('cities/fetchCityMine', {}).then((data) => {
                this.$store.dispatch('regions/fetchAllRegions', { cities: data });
            }),
            this.$store.dispatch('regions/fetchAllRegions', { }),
            !this.medicalRepsBrief.length 
                ? this.$requestStack.setRequest({
                    key: 'medicalreps/fetchAllBrief',
                    promise:  this.$store.dispatch('medicalreps/fetchAllBrief', true)
                }) 
                : this.$requestStack.getRequest('medicalreps/fetchAllBrief').promise,

            !this.specialties.length ? this.$requestStack.setRequest({
                key: 'specialties/fetchAll',
                promise: this.$store.dispatch('specialties/fetchAll'),
            }) : this.$requestStack.getRequest('specialties/fetchAll').promise,

            !this.myMaterials.length ? this.$store.dispatch('materials/fetchMyMaterial', { 
                employeeId: this.userLogin,
                withPrices: this.addPrice 
            }) : null,
            enableCustomerType && !this.customersTypes.length ? this.$store.dispatch('entityType/fetchAll') : null,

            enablePricesTypes && !this.pricesTypes.length ? this.$store.dispatch('pricesTypes/fetchAll') : null
		]).finally(() => {
            this.loading = false;
        })
        
        if (!("geolocation" in navigator)) {
            this.errorStr = 'Geolocation is not available.';
            console.log('Geolocation is not available.')
            return;
        }

        this.gettingLocation = true;

        // get position
        navigator.geolocation.getCurrentPosition(pos => {
            this.gettingLocation = false;
            this.location = pos;
        }, err => {
            this.gettingLocation = false;
            this.errorStr = err.message;
            console.log(err.message)
        })
	},
    
    beforeRouteLeave (to, from, next) {
        this.$store.dispatch('entities/clearEntitiesBrief').then(() => {
            next()
        }).catch(() => {
            next(false)
        })
    },

    metaInfo: {
        title: 'Administrative visit',
        titleTemplate: '%s | Octopharma'
    }
}
</script>
